"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _core = require("@material-ui/core");

var _MuiThemeProvider = require("@material-ui/core/styles/MuiThemeProvider");

var _MuiThemeProvider2 = _interopRequireDefault(_MuiThemeProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formLabelsTheme = (0, _core.createMuiTheme)({
  overrides: {
    MuiFormLabel: {
      asterisk: {
        color: "#db3131",
        "&$error": {
          color: "#db3131"
        }
      },
      root: {
        fontSize: "16px",
        fontWeight: "500"
      }
    },
    MuiFormHelperText: {
      root: {
        fontSize: "12px"
      }
    },
    MuiFormControl: {
      root: {
        width: "82%"
      }
    },
    MuiMenuItem: {
      root: {
        height: "12px",
        fontSize: "12px"
      }
    },
    MuiInput: {
      root: {
        marginTop: "24px"
      },
      formControl: {
        marginTop: "20px"
      },
      disabled: {
        background: "#e5e4e2ad",
        marginTop: "24px"
      }
    },
    MuiSelect: {
      root: {
        marginTop: "10px"
      }
    }
  }
});

function MaterialSelectField(props) {
  var label = props.label,
      data = props.data,
      _props$required = props.required,
      required = _props$required === undefined ? false : _props$required,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === undefined ? false : _props$fullWidth,
      onChange = props.onChange,
      value = props.value,
      rest = (0, _objectWithoutProperties3.default)(props, ["label", "data", "required", "fullWidth", "onChange", "value"]);


  return _react2.default.createElement(
    _MuiThemeProvider2.default,
    { theme: formLabelsTheme },
    _react2.default.createElement(
      _core.FormControl,
      (0, _extends3.default)({}, rest, { fullWidth: fullWidth, style: { paddingBottom: "0px" } }),
      _react2.default.createElement(
        _core.InputLabel,
        { required: required, shrink: true },
        label
      ),
      _react2.default.createElement(
        _core.Select,
        { onChange: onChange, displayEmpty: true, value: value },
        data.map(function (item, index) {
          return _react2.default.createElement(
            _core.MenuItem,
            { key: index, value: item.value, selected: item.value == value },
            item.label
          );
        })
      )
    )
  );
}

MaterialSelectField.defaultProps = { data: [] };
MaterialSelectField.propTypes = { data: _propTypes2.default.array.isRequired };
exports.default = MaterialSelectField;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/components/MaterialSelectField/index.js
// module id = 2143
// module chunks = 1137